import { createFileRoute } from '@tanstack/react-router'
import { TimesheetPage } from '@/common/components/timesheet-page/TimesheetPage'
import { Navbar } from '@/common/components/navbar'

interface TimesheetSearch {
  period_start?: string
}

export const Route = createFileRoute('/timesheets')({
  validateSearch: (search: Record<string, unknown>): TimesheetSearch => ({
    period_start: typeof search.period_start === 'string' ? search.period_start : undefined,
  }),
  component: () => (
    <>
      <Navbar />
      <TimesheetPage />
    </>
  ),
})
